import React, { SVGAttributes } from 'react';

export const MobileChat = (props: SVGAttributes<SVGElement>) => (
  <svg viewBox="0 0 24 24" {...props}>
    <path d="M11 17V7H4v10h7m0-14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7m5.5 0h5A1.5 1.5 0 0 1 23 4.5v3A1.5 1.5 0 0 1 21.5 9H18l-3 3V4.5A1.5 1.5 0 0 1 16.5 3z" />
  </svg>
);
